import { AtSignIcon, HashIcon, MapPinIcon } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type ValidationInfo = {
  email: boolean;
  trackingNumber: boolean;
  zipCode: boolean;
};

export function buildSecondaryInputLabel(
  info: ValidationInfo,
  t: (key: string) => string,
): string {
  const parts: string[] = [];
  if (info.email) parts.push(t("orderIdentification.fields.email"));
  if (info.trackingNumber) parts.push(t("orderIdentification.fields.trackingNumber"));
  if (info.zipCode) parts.push(t("common.fields.zip"));
  return parts.join(" / ") || t("orderIdentification.fields.email");
}

export function buildSecondaryInputIcon(info: ValidationInfo): LucideIcon {
  if (info.email && !info.trackingNumber && !info.zipCode) return AtSignIcon;
  if (!info.email && info.trackingNumber && !info.zipCode) return HashIcon;
  if (!info.email && !info.trackingNumber && info.zipCode) return MapPinIcon;
  return AtSignIcon;
}
